import * as React from 'react'
import autobind from 'autobind-decorator'
import {createStyles, Theme, WithStyles, withStyles, IconButton, Hidden, Drawer, Icon, Typography} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import {Sidebar} from 'src/core/component/Sidebar'
import {RouteComponentProps, withRouter} from 'react-router'


const drawerWidth = 250;

const styles = (t: Theme) => createStyles({
  drawer: {
    [t.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerShow: {
    display: 'block'
  },
  drawerHidden: {
    display: 'none'
  },
  appBar: {
    marginLeft: drawerWidth,
    height: '48px',
    [t.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
  title: {
    display: 'inline-block',
    width: 'auto',
    position: 'fixed',
    top: t.spacing.unit,
    left: `calc(100vw / 2)`,
    color: '#fff',
    textAlign: 'center',
    zIndex: 500,
    [t.breakpoints.down('sm')]: {
      top: '12px',
      left: '60px',
      fontSize: '1rem'
    },
  },
  menuButton: {
    position: 'fixed',
    top: 0,
    left: 0,
    color: '#fff',
    zIndex: 1300,
    [t.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  overlay: {
    position: 'fixed',
    top: 0, left: 0, bottom: 0, right: 0,
    background: 'rgba(0,0,0,.8)',
    zIndex: 1200,
    [t.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: t.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  userMenuWpr: {
    minWidth: '150px',
    padding: '8px 0',
    zIndex: 9999
  },
  menuIcon:{

  }

})

interface IProps extends WithI18n,
  RouteComponentProps<any>,
  WithStyles<typeof styles> {
    activeSidebarItem: boolean;
}

interface IStates {
  actionsAnchor: any;
  activeSidebar: boolean;
  openUserMenu: boolean;
}

class ConsumerBar extends React.Component<IProps, IStates> {
  state = {
    activeSidebar: false,
    openUserMenu: false,
    actionsAnchor: null
  }

  anchorEl: any;

  render() {
    const {classes, match, t, activeSidebarItem} = this.props

    return (
      <>
        <Typography variant="h6" className={classes.title} gutterBottom>{t.market_hall_portal}</Typography>
        
        <IconButton
          color="inherit"
          aria-label="Open drawer"
          className={classes.menuButton}
          onClick={this.toggleSidebar}
          style={{left: this.state.activeSidebar ? `${drawerWidth}px` : 0}}
        >
          <Icon>{this.state.activeSidebar ? 'close' : 'menu'}</Icon>
        </IconButton>
        
        <div 
          className={classes.overlay} 
          style={{display: this.state.activeSidebar ? 'block' : 'none'}}
        >
        </div>

        <nav className={classes.drawer}>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
            <Sidebar isMenuItemActive={activeSidebarItem} basePath={match.url}/>
            </Drawer>
          </Hidden>
        </nav>
        <nav className={[classes.drawer, this.state.activeSidebar ? classes.drawerShow : classes.drawerHidden].join(' ')}>
          <Hidden smUp implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
            <Sidebar isMenuItemActive={activeSidebarItem} basePath={match.url}/>
            </Drawer>
          </Hidden>
        </nav>
      </>
    )
  }

  @autobind
  private toggleSidebar(){
    this.setState({activeSidebar: !this.state.activeSidebar})
  }

  updateAnchor = (anchor) => {
    this.setState({
        actionsAnchor: anchor,
        openUserMenu: !this.state.openUserMenu
    });
  };

  handleClose = event => {
    this.setState({
      openUserMenu: false
  });
 };

}

export default compose(
  withI18n,
  withStyles(styles),
  withRouter,
)(ConsumerBar)



// WEBPACK FOOTER //
// ./src/shared/ConsumerBar/ConsumerBar.tsx